/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHexagonIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-hexagon"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.13 21.32Q7.4 21.32 6.79 20.98Q6.17 20.63 5.83 20L2 13.32Q1.65 12.7 1.65 12Q1.65 11.3 2 10.68L5.83 4Q6.17 3.38 6.79 3.02Q7.4 2.67 8.13 2.67L15.88 2.67Q16.6 2.67 17.21 3.02Q17.82 3.38 18.18 4L22 10.68Q22.35 11.3 22.35 12Q22.35 12.7 22 13.32L18.18 20Q17.82 20.63 17.21 20.98Q16.6 21.32 15.88 21.32Z" fill={color} />
    </svg>
  );
}
